import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchHubletACQ0138 = {
  name: 'BranchHubletACQ0138',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0138, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postVerification,
      postAccountCreation,
      postExistingAccountSelection
    } = getFlowSteps();
    const postVerificationSteps = NextStepManager.replaceStep(Step.HubletSelection, Step.CompanyDetails)(NextStepManager.removeSteps(Step.CompanyName, Step.CompanyDomain)(postVerification));
    const nextSteps = [...preVerification, ...postVerificationSteps, ...postAccountCreation];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};